module.exports = __webpack_public_path__ + "img/main_sy.75e0cc72.jpg";